import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage,
  Font
} from '@react-pdf/renderer';
import { useEffect, useState } from 'react';
import { dateFormatter, getCurrentDateTime } from '../../../../../utils';
import React from "react";
import JsBarcode from "jsbarcode";
import QRCode from "qrcode";

Font.register({
  family: 'Roboto',
  fonts: [{ src: '/Roboto-Bold.ttf', fontWeight: 'bold' }]
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const styles = StyleSheet.create({
  page: {
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  boldText: {
    fontFamily: 'Roboto',
    fontWeight: 'ultrabold',
    fontSize: '10px'
  },
  text: {
    fontSize: 8,
    marginLeft: 10,
    marginRight: 10
  },
  textUnderlined: {
    fontSize: 8,
    textDecoration: 'underline'
  },
  heading: {
    fontSize: 14,
    fontWeight: 'ultrabold',
    marginBottom: 10,
    textAlign: 'center'
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: 15,
    marginTop: 6,
    border: '1.2px solid black',
    paddingLeft: 20,
    paddingRight: 70,
    // paddingBottom: 40,
    paddingTop: 5
  },
  column1: {
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
    marginRight: '10%'
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
    marginLeft: '5%'
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    paddingBottom: 5
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    paddingTop: 8,
    paddingBottom: 8,
    border: '1.2px solid black',
    marginTop: 10,
    color: 'black',
    width: '96%'
  },
  headerText: {
    fontSize: 8,
    fontWeight: 'bold',
    marginLeft: 25,
    marginRight: 25
  },
  columnHeader: {
    width: 'auto'
  },
  columnText: {
    width: '10%',
    textAlign: 'center'
  },
  columnTextWide: {
    width: '17%',
    textAlign: 'center'
  },
  columnTextNarrow: {
    width: '5%',
    textAlign: 'center'
  },
  barcodeContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    paddingHorizontal: 30,
    marginTop: 5,
    marginBottom: 5
  },
  barcodeLeft: {
    flex: 1,
    alignItems: "flex-start"
  },
  barcodeRight: {
    flex: 1,
    alignItems: "flex-end"
  }
});

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

const getCurrentDate = () => {
  const date = new Date();
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

export const IndoorBillManagementDetail1ReportPdf = ({ data, isPublic=false }) => {
  const [barcodeImg, setBarcodeImg] = React.useState("");
    const [qrImg, setQrImg] = React.useState("");
    const [isDownloading, setIsDownloading] = React.useState(false);
    const [isDownloaded, setIsDownloaded] = React.useState(false);
    const [isError, setIsError] = React.useState(false);
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
  const totalSubTotalAmount = data?.indoorService?.reduce((total, item) => total + parseFloat(item.total_amt || 0), 0);
  const totalSubTotalRoomAmount = data?.roomChargeTracker?.reduce(
    (total, item) => total + parseFloat(item.charge || 0),
    0
  );
  const totalRoomCharge = data?.roomChargeTracker?.reduce((total, item) => total + parseFloat(item.net_amt || 0), 0);
  const totalNetAmount = data?.indoorService?.reduce((total, item) => total + parseFloat(item.net_amt || 0), 0);
  const totalDiscountAmt = data?.indoorService?.reduce((total, item) => total + parseFloat(item.disc_amt || 0), 0);
  const addTotalDiscountAmt = data?.indoorService?.reduce(
    (total, item) => total + parseFloat(item.add_discount || 0),
    0
  );
  const addTotalDiscountRoomAmt = data?.roomChargeTracker?.reduce(
    (total, item) => total + parseFloat(item.disc_amt || 0),
    0
  );

  const amountReceivedByIndoorservice = data?.indoorService?.reduce(
    (total, item) => total + parseFloat(item.total_recpt || 0),
    0
  );

  const amountReceivedByReceiptVoucher = data?.receiptVouchers?.reduce(
    (total, item) => total + parseFloat(item.received_amount || 0),
    0
  );

  const amountRefundByRefundVoucher = data?.paymentRefundVouchers?.reduce(
    (total, item) => total + parseFloat(item?.amount || 0),
    0
  );

  const billingDate = formatDate(data?.billing_date);

  const groupedData = data?.roomChargeTracker.reduce((acc, item) => {
    if (!acc[item.ward_name]) {
      acc[item.ward_name] = {
        ward_name: item.ward_name,
        room_no: item.room_no,
        bed_no: item.bed_no,
        date: item.date,
        Rate: item.charge,
        Disc:item.disc_amt,
        totalQuantity: 0,
        totalNetAmount: 0,
        items: []
      };
    }
    acc[item.ward_name].totalNetAmount += item.net_amt;
    acc[item.ward_name].totalQuantity += 1;
    acc[item.ward_name].items.push(item);
    return acc;
  }, {});
  const groupedDataArray = Object.values(groupedData);

  const allServiceItems = data.indoorService.flatMap((indoorServiceItem) => indoorServiceItem.service_items);
  const groupedServiceItems = allServiceItems.reduce((acc, item) => {
    const group = item.sub_group_name.toLowerCase();
    if (!acc[group]) acc[group] = [];
    acc[group].push(item);
    return acc;
  }, {});

  const sortedGroupNames = Object.keys(groupedServiceItems).sort((a, b) => {
    const firstLetterA = a.charAt(0).toLowerCase();
    const firstLetterB = b.charAt(0).toLowerCase();
    return firstLetterA.localeCompare(firstLetterB);
  });

  
  const formatRegTime = (time) => {
    const [hours, minutes] = time.split(':');
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    // Format to 12-hour time
    const options = { hour: '2-digit', minute: '2-digit', hour12: true };
    return date.toLocaleTimeString('en-US', options);
  };

  
    React.useEffect(() => {
      if (!data || typeof window === "undefined") return;
  
      const params = new URLSearchParams(window.location.search);
      const refId = params.get("refId");
  
      // BARCODE
      const canvas = document.createElement("canvas");
      JsBarcode(canvas, String(data.ipd_no), {
        format: "CODE128",
        displayValue: false,
        height: 40
      });
      setBarcodeImg(canvas.toDataURL());
      let path;
      // QR → PUBLIC LINK
      if (refId) {
        if (isPublic) {
          path = window.location.pathname;
        } else {
          path = window.location.pathname.replace("/print/", "/public/print/");
        }
        const qrUrl = `${window.location.origin}${path}?refId=${refId}`;
        QRCode.toDataURL(qrUrl).then(setQrImg);
      }
    }, [data]);
  
  
    const downloadPDF = async () => {
      try {
        // Import pdf dynamically to avoid SSR issues
        const { pdf } = await import('@react-pdf/renderer');
        const blob = await pdf(PdfDoc).toBlob();
        const url = URL.createObjectURL(blob);
  
        // Create download link
        const link = document.createElement('a');
        link.href = url;
        link.download = `Final-Bill-${data.finalBillNo  || Date.now()}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
  
        // Clean up
        setTimeout(() => {
          URL.revokeObjectURL(url);
          setIsDownloading(false);
  
          // Show success message instead of trying to close
          setIsDownloaded(true);
        }, 100);
  
      } catch (error) {
        console.error('Error downloading PDF:', error);
        setIsDownloading(false);
        setIsError(true);
        //alert('Failed to download PDF. Please try again.');
      }
    };
  
  
    React.useEffect(() => {
      if (isPublic && data && barcodeImg && qrImg && !isDownloading) {
        // Small delay to ensure everything is loaded
        const timer = setTimeout(() => {
          downloadPDF();
        }, 1000);
  
        return () => clearTimeout(timer);
      }
    }, [isPublic, data, barcodeImg, qrImg, isDownloading]);

    const PdfDoc=(
      <Document title={`${data.patientName}'s Final Bill`}>
          <Page size="A4" style={styles.page}>
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={{
                width: '100%',
                height: '80px',
                marginBottom: 1,
                marginRight: '5%',
                paddingLeft: '20px',
                marginTop: '2%'
              }}
            />
            <Text
              content={data.billLabel}
              style={{ ...styles.boldText, borderBottom: '1px solid black', fontSize: '18px' }}
            />

              <View style={styles.barcodeContainer}>
                        {/* Left: Barcode */}
                        <View style={styles.barcodeLeft}>
                          {barcodeImg && (
                            <PDFImage
                              src={barcodeImg}
                              style={{
                                width: 160,
                                height: 50
                              }}
                            />
                          )}
                        </View>
              
                        {/* Right: QR Code */}
                        <View style={styles.barcodeRight}>
                          {qrImg && (
                            <PDFImage
                              src={qrImg}
                              style={{
                                width: 75,
                                height: 75
                              }}
                            />
                          )}
                        </View>
                      </View>

            <View style={styles.contentContainer}>
              <View style={styles.column1}>
                <View style={styles.row}>
                  <Text content="UHID NO.             : " style={{ fontSize: 9, fontFamily: 'Roboto' }} />
                  <Text content={`${data.uhid}`} style={{ fontSize: 9 }} />
                </View>
                <View style={styles.row}>
                  <Text content="Name                   : " style={{ fontSize: 9, fontFamily: 'Roboto' }} />
                  <Text content={`${data.patientName}`} style={{ fontSize: 9 }} />
                </View>
                <View style={styles.row}>
                  <Text content="Age/Gender        : " style={{ fontSize: 9, fontFamily: 'Roboto' }} />
                  <Text content={`${data.age} / ${data.gender}`} style={{ fontSize: 9 }} />
                </View>
                <View style={styles.row}>
                  <Text content="Doctor                  : " style={{ fontSize: 9, fontFamily: 'Roboto' }} />
                  <Text content={`${data.consultant.doctor}`} style={{ fontSize: 9 }} />
                </View>
                <View style={styles.row}>
                  <Text content="Department        : " style={{ fontSize: 9, fontFamily: 'Roboto' }} />
                  <Text content={`${data.department}`} style={{ fontSize: 9 }} />
                </View>
                <View style={styles.row}>
                  <Text content="Address              : " style={{ fontSize: 9, fontFamily: 'Roboto' }} />
                  <Text content={`${data.address}`} style={{ fontSize: 9 }} />
                </View>
                <View style={styles.row}>
                  <Text content="Ward/Bed No.    : " style={{ fontSize: 9, fontFamily: 'Roboto' }} />
                  <Text content={`${data?.ward}  /  ${data?.consultantDetail?.bed_no}`} />
                </View>
              </View>
              <View style={styles.column}>
                <View style={styles.row}>
                  <Text content="IPD No                           :" style={{ fontSize: 9, fontFamily: 'Roboto' }} />
                  <Text content={`${data.ipd_no}`} style={{ fontSize: 9 }} />
                </View>
                <View style={styles.row}>
                  <Text content="Bill No.                          :" style={{ fontSize: 9, fontFamily: 'Roboto' }} />
                  <Text content={`${data.finalBillNo || '-'}`} style={{ fontSize: 9 }} />
                </View>
                <View style={styles.row}>
                  <Text content="Bill Date                        :" style={{ fontSize: 9, fontFamily: 'Roboto' }} />
                  <Text content={billingDate} style={{ fontSize: 9 }} />
                </View>
                <View style={styles.row}>
                  <Text content="Addmission Date        :" style={{ fontSize: 9, fontFamily: 'Roboto' }} />
                  <Text content={`${formatDate(data?.admission_date)}/${formatRegTime(data?.admission_time)}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Discharge Date           :" style={{ fontSize: 9, fontFamily: 'Roboto' }} />
                  <Text content={`${data?.dischargeDate === '-' ? '-' : formatDate(data?.dischargeDate)}/${data?.dischargeTime === '-' ? '-' : formatRegTime(data?.dischargeTime)}`}  />
                </View>
                <View style={styles.row}>
                  <Text content="Sponsor                       :" style={{ fontSize: 9, fontFamily: 'Roboto' }} />
                  <Text content={`${data.sponsor}`} style={{ fontSize: 9 }} />
                </View>
                <View style={styles.row}>
                  <Text content="TPA/Insurance           :" style={{ fontSize: 9, fontFamily: 'Roboto' }} />
                  <Text content="" style={{ fontSize: 9 }} />
                </View>
              </View>
            </View>
            <View style={styles.headerContainer}>
              <Text
                content="Description"
                style={{ ...styles.columnTextWide, width: '25%', fontFamily: 'Roboto', fontSize: 9 }}
              />
              <Text
                content="OpDocName"
                style={{ ...styles.columnText, width: '25%', fontFamily: 'Roboto', fontSize: 9 }}
              />
              <Text
                content="Ser Date"
                style={{ ...styles.columnText, width: '10%', fontFamily: 'Roboto', fontSize: 9 }}
              />
              <Text
                content="Unit Rate"
                style={{ ...styles.columnText, width: '10%', fontFamily: 'Roboto', fontSize: 9 }}
              />
              <Text
                content="Day/Qty"
                style={{ ...styles.columnText, width: '10%', fontFamily: 'Roboto', fontSize: 9 }}
              />
              <Text content="Dis." style={{ ...styles.columnText, width: '10%', fontFamily: 'Roboto', fontSize: 9 }} />
              <Text
                content="Amount"
                style={{ ...styles.columnText, width: '12%', fontFamily: 'Roboto', fontSize: 9 }}
              />
            </View>
            {sortedGroupNames.map((groupName, groupIndex) => (
              <>
                <Text
                  style={{
                    ...styles.columnText,
                    width: '90%',
                    textAlign: 'start',
                    fontSize: '10px',
                    marginBottom: '1%',
                    fontFamily: 'Roboto',
                    marginTop: '1%'
                  }}
                  content={groupName.toUpperCase()}
                />
                {groupedServiceItems[groupName].map((serviceItem, serviceIndex) => (
                  <View
                    style={{
                      ...styles.row,
                      borderTop: '1px solid black',
                      borderLeft: '1px solid black',
                      borderRight: '1px solid black',
                      borderBottom: '0.5px solid black',
                      padding: '5px',
                      width: '96%',
                     backgroundColor: serviceIndex % 2 === 0 ? 'white' : '#e0e0e0',
                    
                    }}
                    key={`${groupIndex}-${serviceIndex}`}
                  >
                    <Text style={{ ...styles.columnTextWide, width: '25%' ,fontSize:9}} content={serviceItem.service_name} />
                       <Text style={{ ...styles.columnTextWide, width: '25%' ,fontSize:9}} content={serviceItem.doctor} />
                    <Text
                      style={{ ...styles.columnText, width: '10%',fontSize:9 }}
                      content={formatDate(serviceItem.billingDate)}
                    />
                    <Text style={{ ...styles.columnText, width: '10%',fontSize:9 }} content={serviceItem.rate} />
                    <Text style={{ ...styles.columnText, width: '10%',fontSize:9 }} content={serviceItem.quantity} />
                     <Text style={{ ...styles.columnText, width: '10%',fontSize:9 }} content={serviceItem.disc_amt} />
                    <Text style={{ ...styles.columnText, width: '10%' ,fontSize:9}} content={serviceItem.amount} />
                  </View>
                ))}

                <View style={{ ...styles.row, padding: '5px', marginLeft: '70%' }}>
                  <Text
                    style={{ ...styles.columnTextWide, width: '30%', fontFamily: 'Roboto',fontSize:9 }}
                    content={'Sub Total'}
                  />
                  <Text
                    style={{ ...styles.columnTextWide, width: '10%',fontFamily:"Roboto" ,fontSize:9}}
                    content={groupedServiceItems[groupName].reduce((sum, item) => sum + parseFloat(item.amount), 0)}
                  />
                </View>
              </>
            ))}
            {groupedDataArray.map((group, index) => (
              <>
                <Text
                  content={'ROOM CHARGES'}
                  style={{
                    ...styles.columnText,
                    width: '90%',
                    textAlign: 'start',
                    fontFamily: 'Roboto',
                    fontSize: '10px',
                    marginTop: '1%'
                  }}
                />
                <View
                  key={index}
                  style={{ ...styles.row, marginTop: 10, border: '1px solid black', padding: '5px', width: '96.5%',
                    backgroundColor: index % 2 === 0 ? 'white' : '#e0e0e0',
                   }}
                >
                  <Text
                    content={`${group.ward_name}/${group.room_no}/${group.bed_no}`}
                    style={{ ...styles.columnText, width: '24%',fontSize:9  }}
                  />
                        <Text
                    content=""
                    style={{ ...styles.columnText, width: '12%',fontSize:9 }}
                  />
                  <Text
                    content={formatDate(group.date)}
                    style={{ ...styles.columnText, width: '12%',fontSize:9 }}
                  />
                  <Text
                    content={group.Rate}
                    style={{ ...styles.columnText, width: '12%',fontSize:9 }}
                  />
                  <Text
                    content={group.totalQuantity}
                    style={{ ...styles.columnText, width: '12%',fontSize:9 }}
                  />
                     <Text
                    content={group.Disc}
                    style={{ ...styles.columnText, width: '12%',fontSize:9 }}
                  />
                  <Text content={group.totalNetAmount} style={{ ...styles.columnText, width: '24%',fontSize:9 }} />
                </View>
                <View key={index} style={{ ...styles.row, marginTop: 10, marginLeft: '92%',width:"40%" }}>
                  <Text content={`Sub Total`} style={{ ...styles.columnText, width: '20%', fontFamily: 'Roboto',fontSize:9 }} />
                  <Text content={group.totalNetAmount} style={{ ...styles.columnText, width: '10%' ,fontFamily: 'Roboto',fontSize:9}} />
                </View>
              </>
            ))}
             <View style={{width:"100%",marginLeft:"20%",marginTop:"2%"}}>
            <View style={{ ...styles.row }}>
              <Text
                content="Grand Total                :-"
                style={{ ...styles.columnTextWide, fontWeight: 'bold', marginLeft: '56%', fontFamily: 'Roboto' ,fontSize:9,textAlign:'start'}}
              />
              <Text content={`${totalSubTotalAmount + totalSubTotalRoomAmount}`} style={{ ...styles.columnText,fontFamily:"Roboto" }} />
            </View>
            <View style={{ ...styles.row }}>
              <Text
                content="Discount                     :-"
                style={{ ...styles.columnTextWide, fontWeight: 'bold', marginLeft: '56%', fontFamily: 'Roboto',fontSize:9 ,textAlign:'start'}}
              />
              <Text
                content={`${totalDiscountAmt + addTotalDiscountAmt + addTotalDiscountRoomAmt}`}
                style={{ ...styles.columnText ,fontFamily:"Roboto"}}
              />
            </View>
            <View style={{ ...styles.row }}>
              <Text
                content="Net Bill Amount         :-"
                style={{ ...styles.columnTextWide, fontWeight: 'bold', marginLeft: '56%', fontFamily: 'Roboto' ,fontSize:9,textAlign:'start'}}
              />
              <Text content={`${totalRoomCharge + totalNetAmount}`} style={{ ...styles.columnText,fontFamily:"Roboto" }} />
            </View>
            <View style={{ ...styles.row }}>
              <Text
                content="Amount Received      :-"
                style={{ ...styles.columnTextWide, fontWeight: 'bold', marginLeft: '56%', fontFamily: 'Roboto',fontSize:9 ,textAlign:'start'}}
              />
              <Text
                content={`${amountReceivedByIndoorservice + amountReceivedByReceiptVoucher}`}
                style={{ ...styles.columnText ,fontFamily:"Roboto",fontSize:9}}
              />
            </View>
            <View style={{ ...styles.row }}>
              <Text
                content="Balance                       :-"
                style={{ ...styles.columnTextWide, fontWeight: 'bold', marginLeft: '56%', fontFamily: 'Roboto',fontSize:9,textAlign:'start'}}
              />
              <Text
                content={
       totalSubTotalAmount + totalSubTotalRoomAmount +
                  amountRefundByRefundVoucher -
                  (amountReceivedByIndoorservice +
                    amountReceivedByReceiptVoucher +
                    totalDiscountAmt +
                    addTotalDiscountAmt +
                    addTotalDiscountRoomAmt)
                }
                style={{ ...styles.columnText,fontFamily:"Roboto" }}
              />
            </View>
            </View>

            <Text content="Reciept Voucher" style={{ ...styles.columnTextWide, fontFamily: 'Roboto' ,fontSize:10}} />
            <View style={{ ...styles.headerContainer, width: '100%' }}>
              <Text content="S No." style={{ ...styles.columnTextNarrow, width: '10%', fontFamily: 'Roboto' }} />
              <Text content="Date" style={{ ...styles.columnTextNarrow, width: '10%', fontFamily: 'Roboto' }} />
              <Text content="IPD No." style={{ ...styles.columnText, width: '10%', fontFamily: 'Roboto' }} />
              <Text content="Payment Mode" style={{ ...styles.columnTextWide, width: '25%', fontFamily: 'Roboto' }} />
              <Text content="Receipt No." style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto' }} />
              <Text content="Payment Type" style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto' }} />
              <Text content="Received Amount" style={{ ...styles.columnText, width: '30%', fontFamily: 'Roboto' }} />
            </View>

            {data.receiptVouchers && data.receiptVouchers.length > 0 ? (
              data.receiptVouchers.map((voucher, index) => (
                <View
                  style={{
                    ...styles.row,
                    marginTop: 5,
                    width: '100%',
                    backgroundColor: index % 2 === 0 ? 'white' : '#e0e0e0',
                  }}
                  key={voucher._id}
                >
                  <Text content={index + 1} style={{ ...styles.columnTextNarrow, width: '10%' }} />
                  <Text
                    content={`${formatDate(voucher?.date)} ${voucher?.time}`}
                    style={{ ...styles.columnTextNarrow, width: '15%',fontSize:9 }}
                  />
                  <Text content={data.ipd_no || '-'} style={{ ...styles.columnText, width: '10%',fontSize:9 }} />
                  <Text content={voucher.payment_mode || '-'} style={{ ...styles.columnTextWide, width: '25%',fontSize:9 }} />
                  <Text content={voucher.receipt_no || '-'} style={{ ...styles.columnText, width: '15%' ,fontSize:9}} />
                  <Text content={voucher.payment_type || '-'} style={{ ...styles.columnText, width: '15%',fontSize:9 }} />
                  <Text content={voucher.received_amount || '0'} style={{ ...styles.columnText, width: '30%',fontSize:9 }} />
                </View>
              ))
            ) : (
              <View style={{ ...styles.row }}>
                <Text content="No receipts found" style={{ ...styles.columnTextNarrow, width: '100%' }} />
                <Text content="-" style={styles.columnText} />
                <Text content="-" style={styles.columnTextWide} />
                <Text content="-" style={styles.columnText} />
                <Text content="-" style={{ ...styles.columnText, width: '20%' }} />
              </View>
            )}
            <Text
              content="Refund Voucher"
              style={{ ...styles.columnTextWide, marginTop: '5%', fontFamily: 'Roboto' ,fontSize:10}}
            />
            <View style={{ ...styles.headerContainer, width: '100%' }}>
              <Text content="Sr No." style={{ ...styles.columnTextNarrow, width: '10%', fontFamily: 'Roboto' }} />
              <Text content="Date" style={{ ...styles.columnTextNarrow, width: '10%', fontFamily: 'Roboto' }} />
              <Text content="IPD No." style={{ ...styles.columnText, width: '10%', fontFamily: 'Roboto' }} />
              <Text content="Payment Mode" style={{ ...styles.columnTextWide, width: '25%', fontFamily: 'Roboto' }} />
              <Text content="Reciept No." style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto' }} />
              <Text content="Payment Type" style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto' }} />
              <Text content="Amount" style={{ ...styles.columnText, width: '30%', fontFamily: 'Roboto' }} />
            </View>

            {data.paymentRefundVouchers && data.paymentRefundVouchers.length > 0 ? (
              data.paymentRefundVouchers.map((voucher, index) => (
                <View
                  style={{
                    ...styles.row,
                    backgroundColor: index % 2 === 0 ? 'white' : '#e0e0e0',
                    marginTop: 5,
                    width: '100%'
                  }}
                  key={voucher._id}
                >
                  <Text content={index + 1} style={{ ...styles.columnTextNarrow, width: '10%' ,fontSize:9}} />
                  <Text
                    content={`${formatDate(voucher?.date)} ${voucher?.time}`}
                    style={{ ...styles.columnTextNarrow, width: '15%',fontSize:9 }}
                  />
                  <Text content={data.ipd_no || '-'} style={{ ...styles.columnText, width: '10%',fontSize:9 }} />
                  <Text content={voucher.payment_mode || '-'} style={{ ...styles.columnTextWide, width: '25%',fontSize:9 }} />
                  <Text content={voucher.doc_no || '-'} style={{ ...styles.columnText, width: '15%',fontSize:9 }} />
                  <Text content={voucher.payment_type || '-'} style={{ ...styles.columnText, width: '15%',fontSize:9 }} />
                  <Text content={voucher.amount || '0'} style={{ ...styles.columnText, width: '30%' ,fontSize:9}} />
                </View>
              ))
            ) : (
              <View style={{ ...styles.row }}>
                <Text content="No Refund  Found" style={{ ...styles.columnTextNarrow, width: '100%' }} />
                <Text content="-" style={styles.columnText} />
                <Text content="-" style={styles.columnTextWide} />
                <Text content="-" style={styles.columnText} />
                <Text content="-" style={{ ...styles.columnText, width: '20%' }} />
              </View>
            )}

            <View style={{ ...styles.row, marginTop: '15%' }}>
              <Text
                content="Authorized Signatory"
                style={{ ...styles.columnTextWide, fontWeight: 'bold', marginLeft: '65%' }}
              />
              <Text content="" style={{ ...styles.columnText }} />
            </View>
            <View style={{ ...styles.row, marginTop: '0' }}>
              <Text content="Patient/Attendent Signatory:" style={{ fontWeight: 'bold', marginRight: '60%' }} />
            </View>
            <View style={{ ...styles.row, marginTop: '2%' }}>
              <Text content="Relation With Patient:" style={{ fontWeight: 'bold', marginRight: '60%' }} />
            </View>
            <View style={{ ...styles.row, marginTop: '2%' }}>
              <Text content="Mobile No.:" style={{ fontWeight: 'bold', marginRight: '60%' }} />
            </View>
          </Page>
        </Document>

    )
    if (isPublic) {
    return (
      <div style={{
        backgroundColor: "white",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "Arial, sans-serif",
        padding: "20px",
        textAlign: "center"
      }}>
        <div style={{ marginBottom: "20px" }}>
          <img
            src="/logo_Hospital_m.jpeg"
            alt="Hospital Logo"
            style={{ width: "200px", height: "80px", objectFit: "contain" }}
          />
        </div>

        {isDownloaded ? (
          <div style={{
            padding: "30px",
            backgroundColor: "#f0f9f0",
            borderRadius: "8px",
            maxWidth: "400px",
            border: "1px solid #4CAF50"
          }}>
            <div style={{ fontSize: "24px", color: "#4CAF50", marginBottom: "15px" }}>
              ✓
            </div>
            <div style={{ fontSize: "18px", fontWeight: "bold", color: "#4CAF50", marginBottom: "10px" }}>
              PDF Downloaded Successfully!
            </div>
            <p style={{ fontSize: "14px", color: "#666", marginBottom: "15px" }}>
              Your bill has been downloaded. You can now close this window.
            </p>
            <button
              onClick={() => window.location.href = "about:blank"}
              style={{
                backgroundColor: "#4CAF50",
                color: "white",
                border: "none",
                padding: "10px 20px",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "14px",
                fontWeight: "bold",
                marginTop: "10px"
              }}
            >
              Close This Page
            </button>
          </div>
        ) : isError ? (
          <div style={{
            padding: "30px",
            backgroundColor: "#fff5f5",
            borderRadius: "8px",
            maxWidth: "400px",
            border: "1px solid #f44336"
          }}>
            <div style={{ fontSize: "24px", color: "#f44336", marginBottom: "15px" }}>
              ✗
            </div>
            <div style={{ fontSize: "18px", fontWeight: "bold", color: "#f44336", marginBottom: "10px" }}>
              Download Failed
            </div>
            <p style={{ fontSize: "14px", color: "#666", marginBottom: "15px" }}>
              Failed to download PDF. Please try again.
            </p>
            <button
              onClick={downloadPDF}
              style={{
                backgroundColor: "#1976D2",
                color: "white",
                border: "none",
                padding: "10px 20px",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "14px",
                fontWeight: "bold",
                marginTop: "10px"
              }}
            >
              Try Again
            </button>
          </div>
        ) : (
          <div style={{
            padding: "20px",
            backgroundColor: "#f5f5f5",
            borderRadius: "8px",
            maxWidth: "400px"
          }}>
            <div style={{ fontSize: "16px", fontWeight: "bold", marginBottom: "15px" }}>
              {isDownloading ? "Downloading PDF..." : "Preparing PDF for download..."}
            </div>

            {isDownloading && (
              <div style={{ margin: "20px 0" }}>
                <div style={{
                  width: "40px",
                  height: "40px",
                  border: "4px solid #f3f3f3",
                  borderTop: "4px solid #1976D2",
                  borderRadius: "50%",
                  animation: "spin 1s linear infinite",
                  margin: "0 auto"
                }} />
                <style>
                  {`
                  @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                  }
                `}
                </style>
              </div>
            )}

            <p style={{ fontSize: "14px", color: "#666", marginBottom: "15px" }}>
              Your bill will download automatically.
            </p>

            {!isDownloading && (
              <button
                onClick={downloadPDF}
                style={{
                  backgroundColor: "#1976D2",
                  color: "white",
                  border: "none",
                  padding: "10px 20px",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "bold",
                  marginTop: "10px"
                }}
              >
                Click to Download
              </button>
            )}
          </div>
        )}
      </div>
    );
  }
  

  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        {PdfDoc}
      </PDFViewer>
    </div>
  );
};
